$(document).ready(function () {
    // if ($("#shopify-section-home-banner .owl-dots").length > 1 ) {
    //     $("#shopify-section-home-banner .owl-dots").css({'cssText': 'display: flex !important'});
    // }
    var pathSort = window.location.href;
    var pathArr = pathSort.split("=");
    var splitArr = pathArr[1];
    var splittedArr = splitArr.split("#");
    var splittedString = splittedArr[0];
    $(".bg_transfer").each(function(){
      var dataAttribute =   $(this).attr("data-select");
        if (splittedString == dataAttribute) {
            $(this).addClass("sort-by-selected-active");
        }
    });

    video_popupSkin();
    $('.js-owl_bestseller--new-arrivals').owlCarousel({
        loop:true,
          margin:10,
          nav:true,
          // autoplay: true,
          responsive:{
              0:{
                  items:1
              },
              600:{
                  items:2
              },
              1000:{
                  navigation: true,
                  items:3
              }
          }
    });
    $(".acc_pro_head").each(function(i){
        len=$(this).text().length;
        if(len>40)
        {
        $(this).text($(this).text().substr(0,40)+'…');
        }
    });

    $(function() {
        $('.clear-cart').on('click',function(e){
        //   e.preventDefault();
          $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            success: function(){
              window.location.href="";
            },
            dataType: 'json'
          });
        })
    });
    var pathname = window.location.href;
    if (pathname.includes("collections")) {
        if ( $(window).width() < 768 ) {
            document.getElementById("sort-by").size = "1";
        }else{
            document.getElementById("sort-by").size = "6";
        }
        $(window).resize(function() {
            if ( $(window).width() < 768 ) {
                document.getElementById("sort-by").size = "1";
            } else {
                document.getElementById("sort-by").size = "6"; 
            }
        });
    }

   $('.js-input-focus-cart').each(function(){
        $(this).blur(function() {
            $(".cart__submit-control").click();
        });
    });
    // var intials = $('.js-customer-nameas-profile-image').text().charAt(7);
    // var profileImage = $('#profileImageInitials').text(intials);
    // var informationInitials = $('#informationInitials').text(intials);

    document.querySelectorAll('.address-delete-form').forEach((deleteForm) => {
        deleteForm.addEventListener('submit', (event) => {
            const confirmMessage = event.target.getAttribute('data-confirm-message');
    
            if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
                event.preventDefault();
            }
        });
    });

    // $(".js-my-account-cta").click(function(){
    //     $(".js-login-modal-body-wrapper").css({"display":"block"});
    //     $('.js-modal-title').text("SIGN IN");
    //     $(".js-password-reset-form").css({"display":"none"});
    //     $("#myLoginModal").modal("show");
        
    // });
    $(".js-forgot-error-msg").click(function(){
        $("#myLoginModal").modal("show");
        $(".js-login-modal-body-wrapper").css({"display":"none"});
        $('.js-modal-title').text("FORGOT YOUR PASSWORD?");
        $(".js-password-reset-form").css({"display":"block"});
    });
    
    $(".quick_desc").each(function(i){
        len=$(this).text().length; 
        if(len>160)
        {
          $(this).text($(this).text().substr(0,160)+'…');
        } 
    });
    $('#sort-by').change(function(){
            localStorage.setItem('mySelectLocalstorageValue', $(this).val());
    });
    var selectedValue = localStorage.getItem('mySelectLocalstorageValue');
   $("."+ selectedValue).attr("selected"," selected");


// Sortby selected option from local storage ends here
   
    $("#js-sign-in-forgot-password").on("click",function(){
        $('.js-password-reset-form').css({"display":"none"});
        $(".js-login-modal-body-wrapper").css({"display":"block"});
    })

//==========For account page greeting message starts here===========
var thehours = new Date().getHours();
var themessage;
var morning = ('Good morning');
var afternoon = ('Good afternoon');
var evening = ('Good evening');

if (thehours >= 0 && thehours < 12) {
    themessage = morning; 

} else if (thehours >= 12 && thehours < 17) {
    themessage = afternoon;

} else if (thehours >= 17 && thehours < 24) {
    themessage = evening;
}

$('.js-account-greetings').append(themessage);
//For overview page greeting message ends here

// edit address popup thing starts here
$('.address-edit-form').on('click',function(){
    var add_id = $(this).attr('data-form-id');
    var country = $('#AddressCountry_'+add_id).attr('data-default');
    $('#AddressCountry_'+add_id+' option').each(function(index){
        if($(this).attr('value') == $('#AddressCountry_'+add_id).attr('data-default')){
            $(this).attr('selected','');
        }
    });
    $('.addresses-list .active').removeClass('active');
    $('#EditAddress_'+add_id).addClass('only-active');
    // $('.edit-address-form').scrollTop();
    // $('html, body').animate({
    //     scrollTop: $('#EditAddress_'+add_id).offset().top - 82
    // }, 1000);    
    return add_id;
  });
// edit address popup thing ends here
})
var intials = $('.js-customer-nameas-profile-image').text().charAt(7);
var profileImage = $('#profileImageInitials').text(intials);
var informationInitials = $('#informationInitials').text(intials);
$(".js-my-account-cta").click(function(){
    $(".js-login-modal-body-wrapper").css({"display":"block"});
    $('.js-modal-title').text("SIGN IN");
    $(".js-password-reset-form").css({"display":"none"});
    $("#myLoginModal").modal("show");
});


// ============== All Parsley form initialization starts here ===========
$('#signin-form').parsley();
$('#forgot-password-form').parsley();
$('#signup-form').parsley();
$("#add-address-form").parsley();
$('.edit-address-form').parsley();
$("#change-password-form").parsley();
// ============== All Parsley form initialization ends here ===========


$(".js-forgot-password").on("click", function() {
    $(".js-login-modal-body-wrapper").css({"display":"none"});
    $('.js-modal-title').text("FORGOT YOUR PASSWORD?");
    $(".js-password-reset-form").css({"display":"block"});
})
// For toggling forms(reset password) from the signin modal
$("#js-sign-in-forgot-password").on("click",function(){
    $(".js-modal-title").text("SIGN IN");
    console.log("js-sign-in-forgot-password clickedclicked");
    $('.js-password-reset-form').css({"display":"none"});
    $(".js-login-modal-body-wrapper").css({"display":"block"});
})

// // toggling signup from signin modal
$(".js-toggle-from-signin-to-signup").on("click",function(){
    $(".js-modal-title").text("CREATE AN ACCOUNT");
    console.log("doing display none");
    $("#myLoginModal").modal("hide");
    $("#mySignupModal").modal("show");
    // $("#mySignupModal").css({'cssText': 'display: block !important'});
    // $("#mySignupModal").css({"display":"block"});
})
// For toggling forms from the signup modal
$(".js-signin-toggle-from-signup-form").on("click",function(){
    $(".js-modal-title").text("SIGN IN");
    console.log("clicked");
    $("#myLoginModal").modal("show");
    $("#mySignupModal").modal("hide");
    
})

// $(".js-account-benefits-signup-btn").on("click", function() { 
//     // $('#testIdForSignin').css({"display":"none"});
//     // $("#testIdForSignup").css({"display":"block"});
// })
// js-show-paswword-input
// Show and Hide Pasword in signup Form
$('.show-icon-for-password').click(function(){
    console.log("hoho");
    if($('.js-show-paswword-input').attr('type') === 'password'){
      $('.js-show-paswword-input').prop('type', 'text');
      $(this).css({"opacity":0.5,"display":"block"});
    }
    else if($('.js-show-paswword-input').attr('type') === 'text'){
      $('.js-show-paswword-input').prop('type', 'password');
      $(this).css({"opacity":1,"display":"block"});
    }
  });



//   var dashboardPhone = $('.us-style-number').text();
//   var dashboardPhone2 = dashboardPhone.replace("+1", "");
//   dashboardPhone2 = dashboardPhone2.replace(/[^0-9]/g, '');
//   dashboardPhone2 = dashboardPhone2.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
//   var finalPhone2 = dashboardPhone2;
//   var finalPhone2 = $('.us-style-number').text();

// Sortby dropdown for collections skincare page starts here

Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
$('#sort-by')
  .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}')
  .bind('change', function() {
    Shopify.queryParams.sort_by = $(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  });


// $('.js-order-filter').change(function() {
//     var selectedOption = $(this).val();
//     console.log(selectedOption);
//     // today's date
//     var today = new Date();
//     var date = today.getDate()+'-'+(today.getMonth()+1)+'-'+today.getFullYear();
//     console.log(date,"date it isss");


//     // 7 Days
//     today.setDate(today.getDate() - 7);

//     var finalDate7 = today.getDate()+'-'+ (today.getMonth()+1) +'-'+today.getFullYear();
//     // console.log(finalDate7,"finalDate7777");

//     // 14 Days
//     var currentTime = new Date();
//     currentTime.setDate(currentTime.getDate()-14);

//     var finalDate14 = currentTime.getDate()+'-'+ (currentTime.getMonth()+1) +'-'+currentTime.getFullYear();
//     // console.log(finalDate14,"finalDate141414");

//     // 30 Days

//     var thirtyDays = new Date();
//     thirtyDays.setDate(thirtyDays.getDate()-30);

//     var finalDate30 = thirtyDays.getDate()+'-'+ (thirtyDays.getMonth()+1) +'-'+thirtyDays.getFullYear();
//     // console.log(finalDate30,"finalDate303030");

   
//     // var splitDate = $(".js-created-at").text();
//     // var splitDateArr = splitDate.split("/");
//     // console.log('path arr', splitDateArr);
//     // splitedDate = splitDateArr[1];
//     // console.log('splitedDate', splitedDate);

//     if(selectedOption == 'All') {
//         console.log("selected is all");
//     }
//     else if (selectedOption == '7 Days') {
//         console.log("selected is 7 days");
        
//         if ($(".js-created-at").text() == finalDate7)
//         {
//             console.log("hola");
//             $('.js-created-at').closest(".line-item-div").css({"display":"none"});
//         }
//         else {
//             console.log ("hola expresssion");
//         }


//     }
//     else if (selectedOption == '14 Days') {
//         console.log("the selected value is 14 days")
//         if ($(".js-created-at").text() == finalDate14) 
//         {
            
//         }

//     }
//     else if (selectedOption == '30 Days') {
//         console.log("selected is 30 days");
//         if ($(".js-created-at").text() == finalDate30) 
//         {
            
//         }
//     }
//     else {
//         console.log("nothing");
//     }

// });

function base_render(orders) {
    for (let i=0; i< orders.length; i++) {
      document.getElementById('js-line-item-div').innerHTML += render_skleton(orders[i])
    }
}

function render_skleton(order) {
    let html = '<div class="row changed-border-bottom ">'
    html += '<div class="padding-b-10 col-md-5">'
    html += '<div class="row">'
    html += '<div class="col-6 col-md-7">'
    html += '<div>'
    html += '<span class="pt-book-15 text-uppercase my-orders-text-color">order placed</span>'
    html += '<p class="pt-medium-19 js-created-at">'+ order.createdDate + '</p>'
    html += '</div></div>'
    html += '<div class="col-6 col-md-5 right-align-class"><div>'
    html += '<span class="pt-book-15 right-align-class my-orders-text-color">TOTAL</span>'
    html += '<p class="pt-medium-19 white-space--desktop">'+ order.lineItemPrice +'</p>'
    html += '</div></div></div></div>'
    html += '<div class="col-md-7">'
    html+= '<div class="row padding-b-20-mobile">'
    html+= '<div class="col-6 col-md-4 ">'
    html+= '<span class="pt-book-15 my-orders-text-color">SHIP TO </span>'
    html+= '<p class="pt-medium-19">'+ order.addressShipping +'</p>'
    html+= '</div>'
    html+= '<div class="col-6 col-md-4 mob_txt_right">'
    html+= '<span class="pt-book-15 track_num_label my-orders-text-color">FULFILLMENT STATUS</span>'
    html+= '<p class="track_num pt-medium-19">'+order.fulfillmentTrackNo+'</p>'
    html+= '</div>'
    html+= '<div class="col-6 col-md-4 offset-md-0 mob_txt_left right-align-class">'
    html+= '<span class="pt-book-15 my-orders-text-color">ORDER NUMBER</span>'
    html+= '<p class="pt-medium-19">' + order.orderNumber+ '</p>'
    html+= '</div>'
    html+= '</div>'
    html+=  '</div>'
    html+= ' </div>'
    html+=  '<div class="row changed-background">'
    html+= '<div class="col-12 col-md-6">'
    html+= '<div>'
    html+= '<div class="line-item-img-wrapper position-relative">'
    html+= '<img class="image" src=" ' + order.lineItemImage + '  " /> '
    html+= '<p class="my_order_quantity">'+ order.productQuantity+'</p>'
    html+= '</div>'
    html+= '<div class="my-orders-line-item-title">'
    html+= '<a href=" ' + order.lineItemUrl+ ' ">'+ order.title +'</a>'
    html+= '<p>'+ order.productType+'</p>'
    html+= '<div>'
    html+= '<span> ' + order.variantTitle +'</span>'
    html+= '<span class="annaknkanak">'+ order.lineItemPrice +'</span>'
    html+= '</div>'
    html+= '</div>'
    html+= '</div>'
    html+=  '</div>'
    html+= '<div class="col-12 offset-md-1 col-md-4 text-center">'
    html+= '<button class="text-uppercase view-order-btn border-0" data-toggle="modal" data-target="#viewOrderModal'+order.orderNumber+'" img-src="' + order.lineItemImage + '">view order </button>'
    html+= '<a href="'+order.fulfillmentTrackUrl+'" target="_blank"><button class="text-uppercase track-order-btn" img-src="' + order.lineItemImage + '">Track order </button></a>'
    html+=  '</div>'
    html+=  '</div>'
    return html
  }

//   $('#viewOrderModal').on('click',function(){
//       var src = $(this).attr('img-src');
//       console.log(src);
//       setTimeout(function(){ 
//         $('.order-preview-popup').attr('src',src);
//         console.log('this is the end');
//       }, 3000);
//   });

$(function () {
    $("#viewOrderModal").click(function () {
        var srcImg = $(this).attr('img-src');
        $('.order-preview-popup').attr('src',srcImg);
        console.log(srcImg);    
    });
});


$(".js-page-404-button").click(function(){
    document.location.href = "https://www.elevatione.com/";
})


// =================== cart-page item increment and decrement functionality starts here  ====================

$(".js-icon-quantity").on("click", function() {
    console.log($(this));
    let updatedQuantityVal = 0;
    let currentQuantityVal = Number($(this).closest("span").siblings(".product-page__quantity-input").val());
    console.log(typeof currentQuantityVal);
    if($(this).hasClass("js-icon-plus")) {
        console.log('plus clicked');
        if(currentQuantityVal >= 1) {
            console.log($(this), $(this).attr("class").split(' '), $(this).hasClass("js-icon-quantity--cart"), ">1 +");
            
            updatedQuantityVal = currentQuantityVal + 1;
            $(this).closest("span").siblings(".product-page__quantity-input").val(updatedQuantityVal);
            if($(this).hasClass("js-icon-quantity--cart")) {
                console.log('submiteee');
                $(this).closest('form').submit();
                
            }  
        }
        console.log(currentQuantityVal, updatedQuantityVal)
    }
    else if($(this).hasClass("js-icon-minus")) {
        if(currentQuantityVal > 1) {
            console.log('minus', currentQuantityVal);
            updatedQuantityVal = currentQuantityVal - 1;
            console.log($(this), $(this).attr("class").split(' '), $(this).hasClass("js-icon-quantity--cart"), ">1 -");
            $(this).closest("span").siblings(".product-page__quantity-input").val(updatedQuantityVal); 
            if($(this).hasClass("js-icon-quantity--cart")) {
                console.log('submiteee');
                $(this).closest('form').submit();
                
            }
        }
        console.log(currentQuantityVal, updatedQuantityVal, "minus clicked")
    }
});

// =================== cart-page item increment and decrement functionality ends here  ====================

$('.variant_cus_product_price_1').addClass('active');
// $('.variants-skin-border').addClass('border-black');

$('.variants-skin-border').on('click',function(e){
    // $(this).addClass("border-black");
    // $(this).removeClass("border-black");

    $(".variants-skin-border").each(function(){
        $(this).removeClass("border-black");
    })
    $(this).addClass("border-black");

    $('.variant_cus_product_price_1').removeClass('active');
    $('.variant_cus_product_price').removeClass('active');
    // $('.variants-skin-border_1').removeClass('active');
    // $('.variants-skin-border').removeClass('active');
    variant_id = $(this).attr('value');
    $('#CartCount_addcart_' + this.dataset.firstVariantId).attr('data-variant-id', variant_id);
    $('#'+variant_id).addClass('active');
 
});

$(".js-add-to-cart-skin").click(function () {
    let data = {
        quantity: 1,
        id: this.dataset.variantId
    }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
        success: function(response) {
            $("#success_ajax_cart li").html('');
            $("#success_ajax_cart li").html('Item added to your bag | <a href="/cart">View Cart</a>');
            $("#success_ajax_cart").show();
            setTimeout(function() {
                $("#success_ajax_cart").hide();
            }, 7000);
            $('.modal').each(function(){
                $(this).modal('hide'); 
            });
            $.getJSON('/cart/update.js', function(cart) {
                console.log(cart.item_count);
                $(".num_count").each(function(){
                    $(this).html(cart.item_count );
                });
            });
        },
        error:function(err){
        }
    });
});
function goBack() {
    window.location.href = '/account';
}
$("#js_search_again").click(function () {
    $(".search-icon-container").click();
})

$("#js-change-password").click(function(){
    // $("")
    // $(".js-login-modal-body-wrapper").css({"display":"none"});
    // $('.js-modal-title').text("FORGOT PASSWORD");
    $(".js-password-reset-form").css({"display":"block"});
    $("#changePasswordModal").modal("show");
})


// $(document).on('submit','form#change-password-form',function(){
//     setTimeout (function() {
//         $("#customer_logout_link").click();
//         // $('#ResetSuccess').css({"display":"block"});
//         // $('.hide-forgot-password').css({"display":"none"});
//         // console.log("submitting recover password form");

//         // window.location.href = "/account/logout";
//         // window.location.href = "/account/login";
//         // console.log("they are logged out");
//     },200)
    
// });


// window.addEventListener('load',function(){
//     setTimeout (function(){
//         $('#js-tabs-bestseller').slick({
//             slidesToShow: 3
//         });
//     },200)
// })

function video_popupSkin(){
    $('.js-play-btn').magnificPopup({
        type: 'iframe',
        iframe: {
            markup: '<div class="mfp-iframe-scaler">' +
                '<div class="mfp-close"></div>' +
                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
    
            patterns: {
                youtube: {
                    index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
    
                    id: 'v=', // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }
    
                    src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0' // URL that will be set as a source for iframe.
                },
                vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: '//player.vimeo.com/video/%id%?autoplay=1'
                },
                gmaps: {
                    index: '//maps.google.',
                    src: '%id%&output=embed'
                }
    
                // you may add here more sources
    
            },
    
            srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        }
    });
}


function video_popupSkin(){
    $('.js-play-btn').magnificPopup({
        type: 'iframe',
        iframe: {
            markup: '<div class="mfp-iframe-scaler">' +
                '<div class="mfp-close"></div>' +
                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
    
            patterns: {
                youtube: {
                    index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
    
                    id: 'v=', // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }
    
                    src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0' // URL that will be set as a source for iframe.
                },
                vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: '//player.vimeo.com/video/%id%?autoplay=1'
                },
                gmaps: {
                    index: '//maps.google.',
                    src: '%id%&output=embed'
                }
    
                // you may add here more sources
    
            },
    
            srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        }
    });
}




// inserting video and banner inside the loop
if(document.getElementById("collection-skin") != null){
  let productList = document.getElementById("collection-skin");
  let items = productList.getElementsByClassName("looping_item");
  let rand_id = Math.floor((Math.random()*10)+1);
  for(let i=0; i<items.length; i++) {
      //console.log(i)
      if(i === rand_id && ADS_BANNER_IMG){
          let content = '<div class="col-6 col-xl-3 looping_item column-margin-bottom css-column-margin wow fadeInUp" data-wow-delay="0.25s" style="visibility:hidden"><div class="inner_pro_img">'
              content +=  '<a class="inner_pro_img_link" href="'+ADS_BANNER_LINK+'">'
              content +=  '<img src="'+ADS_BANNER_IMG+'" alt="" class="">'
              content +=  '</a>'
              content +=  '<a href="'+ADS_BANNER_LINK+'"></a>'
              content +=  '</div> </div>'
              items[i].insertAdjacentHTML("afterend", content);
      }

      if(i === 11 && YOUTUBE_THUMBNAIL && YOUTUBE_VIDEO && YOUTUBE_PLAYBUTTON) {
          let content ='<div class="col-12 col-md-12 offset-xl-1 col-xl-10 column-margin-bottom-video js-column-margin-bottom-video wow fadeInUp" data-wow-delay="0.25s" style="visibility:hidden">'
              content +=  '<div class="column-wrapper-mobile">'
              content +=  '<div class="inner_pro_img">'
              content +=  '<a class="inner_pro_img_link" href="">'
              content +=  '<img src="'+YOUTUBE_THUMBNAIL+'" alt="" class="">'
              content +=  '</a>'
              content +=  '<a href="'+YOUTUBE_VIDEO+'" class="big-banner-play-btn js-big-banner-play-btn js-play-btn">'
              content +=  '<img src="'+YOUTUBE_PLAYBUTTON+'" class="play-btn-size">'
              content +=  '</a></div></div></div>'

          items[i].insertAdjacentHTML("afterend", content);
          video_popupSkin();
      }else{
          $("img[src='']").parent(".product-video").addClass("d-none");
      }
  }
}



// ajax pagination for next page
function nextPageSkin(that) {
    $.ajax({
        type: "GET",
        url: that.dataset.nextPage,
        success: (response) => {
            let parser =  new DOMParser().parseFromString(response, 'text/html');
            $('div#AjaxinateLoop div.row').append(parser.getElementById('AjaxinateLoop').querySelector('div').innerHTML);
            parser.getElementById('loadNextPage') ? $('div#loadNextPage').html(parser.getElementsByClassName('load-more-wrapper')[0].innerHTML): $('div.load-more-wrapper').remove();
            ASYNC = false
        },
      });
    return false
}

ASYNC = false;

$(window).bind('scroll', () => {
    if ($(this).scrollTop() > $('#AjaxinateLoop div.row')[0].scrollHeight && ASYNC === false) {
        // console.log($('#AjaxinateLoop')[0].scrollHeight, "HEIGHT")
        ASYNC = true
        $('#autoLoadMore').click();
        return false
    }
})


$('.inner_pro_img_link').on('click',function(){
    var pathnameArr = window.location.pathname.split('/');
    var last = pathnameArr[pathnameArr.length - 1];
    localStorage.setItem('collection-handle',last);
    localStorage.setItem('collection-name',$('.current_breadcrum').html());
    // $('.dynamic-collection-link').attr('href','/collections/'+localStorage.getItem('collection'));
    // $('.dynamic-collection-link').html(localStorage.getItem('collection'));
    // alert(localStorage.getItem('collection'))
});